var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "day-configurator-body d-flex" },
    [
      _vm.canEdit
        ? _c("day-configurator-practical-details", {
            attrs: {
              items: _vm.items,
              "loading-google-location": _vm.loadingGoogleLocation
            },
            on: {
              "next-step": function($event) {
                return _vm.changeStep("planning")
              },
              "previous-step": function($event) {
                return _vm.changeStep("practical-details")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("day-configurator-planning", {
        attrs: { items: _vm.items },
        on: {
          "previous-step": function($event) {
            return _vm.changeStep("practical-details")
          }
        }
      }),
      _vm._v(" "),
      _vm.canEdit
        ? _c("day-configurator-side-panel", {
            class: { active: _vm.activeStep === "request-offer" },
            on: {
              "previous-step": function($event) {
                return _vm.changeStep("planning")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }